import { render, staticRenderFns } from "./CleanLayout.vue?vue&type=template&id=35cd7ff6&scoped=true&"
import script from "./CleanLayout.vue?vue&type=script&lang=js&"
export * from "./CleanLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cd7ff6",
  null
  
)

export default component.exports